import { hasPageToken } from './pageTokens';

// Temporary permissions utility - to be replaced with proper permission checking later

export const PERMISSIONS = {
  // Newsfeed permissions
  NEWSFEED_EDIT: true,
  NEWSFEED_DELETE: true,
  NEWSFEED_CREATE: true,

  // General permissions
  ADMIN_ACCESS: true,
  USER_MANAGEMENT: true,

  // Chapter permissions
  CHAPTER_MANAGEMENT: true,
  CHAPTER_EDIT: true,

  // Member permissions
  MEMBER_MANAGEMENT: true,
  MEMBER_EDIT: true,
} as const;

export type PermissionKey = keyof typeof PERMISSIONS;

export const hasPermission = (permission: PermissionKey): boolean => {
  return PERMISSIONS[permission];
};

export const checkMultiplePermissions = (
  permissions: PermissionKey[]
): boolean => {
  return permissions.every((permission) => PERMISSIONS[permission]);
};

export const canViewTransferRequests = (): boolean => {
  return hasPageToken(localStorage.getItem('pages'), 'seeking-transfer');
};

/** Matches permission_name from getMyPermissions (supports `appId,permission:name` entries). */
export function hasUserApplicationPermission(
  permissions: string[] | undefined,
  permissionName: string
): boolean {
  if (!permissions?.length || !permissionName) return false;
  return permissions.some((entry) => {
    if (entry === permissionName) return true;
    const comma = entry.lastIndexOf(',');
    if (comma >= 0) {
      return entry.slice(comma + 1).trim() === permissionName;
    }
    return false;
  });
}
